import BaseInputLayout, { BaseInputLayoutProps } from './BaseInputLayout';
import React from 'react';
import { Box } from '@mui/material';

const IconInputLayout = ({ label, children, ...props }: BaseInputLayoutProps) => {
  return (
    <BaseInputLayout {...props}>
      <Box display="flex" alignItems="center">
        {label as any}
        {children}
      </Box>
    </BaseInputLayout>
  );
};

export default IconInputLayout;
